import React from 'react';
import cx from 'clsx';
import Link from '../Link';
import * as themeStyles from '../../assets/theme.module.scss';

const NewsCard = ({
    title, date, url, excerpt, tags,
}) => (
    <article className={cx(themeStyles.card, themeStyles.shadowLightLg, themeStyles.mb5)}>
        <div className={themeStyles.cardBody}>
            <Link to={url}>
                <h2 className={themeStyles.h2}>{title}</h2>
            </Link>

            <p className={cx(themeStyles.fontSizeSm, themeStyles.textGray800, themeStyles.mb5)}>{excerpt}</p>
            <div className={cx(themeStyles.alignItemsCenter, themeStyles.dNone, themeStyles.dMdFlex)}>
                <div className={themeStyles.flexGrow1}>
                    {tags && tags.map((tag) => (
                        <span
                            key={tag.name}
                            className={cx(themeStyles.badge, themeStyles.badgePrimaryDesatSoft, themeStyles.badgePill, themeStyles.mb3, themeStyles.mr1)}
                        >
                            <span className={cx(themeStyles.h6, themeStyles.textUppercase)}>
                                {tag.name}
                            </span>
                        </span>
                    ))}
                </div>
                <div>
                    <h6 className={cx(themeStyles.fontWeightBold, themeStyles.textUppercase, themeStyles.textGray700)}>
                        {date}
                    </h6>
                </div>
            </div>
        </div>
    </article>
);

export default NewsCard;
